import { cn } from '../../../../lib/utils';

export interface FeedbackState {
  variant: 'success' | 'error';
  message: string;
}

const FeedbackBanner = ({ feedback }: { feedback: FeedbackState | null }) => {
  if (!feedback) return null;
  return (
    <div
      className={cn(
        'rounded-lg border px-4 py-3 text-sm font-medium',
        feedback.variant === 'success'
          ? 'border-success-light bg-surface-success text-text-default'
          : 'border-error-light bg-error-light text-error'
      )}
    >
      {feedback.message}
    </div>
  );
};

export default FeedbackBanner;
